import { Route } from 'vue-router';
import _ from 'lodash';
import { sendSegmentPageview } from '../../lib/segment';

const segmentPageviews = (to: Route, from: Route) => {
  try {
    const componentTitle = (to.matched[0]?.components?.default as { name?: string })?.name;
    const processedName = _.startCase(_.replace(to.name || '', /-/g, ' ')) || 'Unknown Page';

    sendSegmentPageview(`Sittercity-Web: ${processedName}`, {
      title: componentTitle,
      url: document.location.href,
      path: document.location.pathname,
      referrer: from.fullPath ? document.location.origin + from.fullPath : undefined,
      search: document.location.search || undefined,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Segment tracking failed:', error);
  }
};

export default segmentPageviews;
